var exports = {
  "k": "xfb577c5e--a3634f--container",
};

module.exports = exports;
